import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HomeMobile from './homeMobile';
import HomeWeb from './homeWeb';
import UserNpsModal from './user-nps/userNpsModal';
import SuccessMessage from '../components/successMessage';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const HomeRouter = () => {
  const width = useWindowWidth();
  const navigate = useNavigate();

  const [nps, setNps] = useState(null);
  const [npsModalOpen, setNpsModalOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const userEmail = sessionStorage.getItem('userEmail');
    if (!userEmail) return;

    // NPS DISABLED
    // quarkusApi
    //   .get(`/nps/${userEmail}`, {
    //     headers: { Authorization: sessionStorage.getItem('token') },
    //   })
    //   .then((response) => {
    //     if (response.data) {
    //       setNps(response.data);
    //       setNpsModalOpen(true);
    //     }
    //   })
    //   .catch((error) => {
    //     if (error.response?.status === 401) {
    //       navigate('/expired-session');
    //     }
    //   });
  }, [navigate]);

  const handleNpsClose = (submitted) => {
    setNpsModalOpen(false);
    if (submitted) {
      setNps(null);
      setShowSuccessMessage(true);
    }
  };

  const MOBILE_BREAKPOINT = 768;

  return (
    <>
      {width < MOBILE_BREAKPOINT ? <HomeMobile /> : <HomeWeb />}
      <UserNpsModal open={npsModalOpen} onClose={handleNpsClose} nps={nps} />
      {showSuccessMessage && (
        <SuccessMessage
          message="Muito obrigado! Sua opinião é muito importante para nós."
          show={showSuccessMessage}
          setShow={setShowSuccessMessage}
        />
      )}
    </>
  );
};

export default HomeRouter;
